import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { Form, Text, Select } from 'react-form';
import { api } from '@src/services/api';
import { checkLevel, isLevel, isReadOnly } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoList, PropsList, StateList } from '@src/components/Proto';
import { SettingsBattery as Edit, Box } from '@src/components';
import { Battery as Actions } from '../Actions/Battery';
import { BatteryMount } from '../Actions/BatteryMount';
import { BatteryShare } from '../Actions/BatteryShare';

// typing
interface LocalProps extends PropsList {
    urlCreateDepartment: string;
    urlWorkflowDevices: string;
    urlWorkflowMountBattery: string;
    urlWorkflowUnmountBattery: string;
    urlWorkflowCustomers: string;
    urlWorkflowShareData: string;
    urlWorkflowUnshareData: string;
}
interface LocalState extends StateList {
    actioning?: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Battery extends ProtoList<LocalProps, LocalState> {
    
    ActionBtn = act => {
        return row => {
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.openAction(act, row.row);
                        } }
                    >
                        {act.toUpperCase()}
                    </button>
                </div>
            );
        }
    };

    MountBtn = () => {
        return row => {
            if (row.original.mounted==null) return null;
            const act = row.original.mounted ? 'unmount' : 'mount';
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.openAction(act, row.original);
                        } }
                    >
                        {_(`${act}_battery_btn`, 'SettingsBattery')}
                    </button>
                </div>
            );
        }
    }

    ShareBtn = () => {
        return row => {
            if (!row.original.mounted) return null;
            const act = row.original.shared ? 'unshare' : 'share';
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.openAction(act, row.original);
                        } }
                    >
                        {_(`${act}_battery_btn`, 'SettingsBattery')}
                    </button>
                </div>
            );
        }
    }

    openAction = (action, row) => {
        const { fields } = this.props;
        this.setState({
            action: action.toUpperCase(),
            actioning: row[fields.id]
        });
    }

	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { cpt, onBattery, urlShow, urlCreate, urlUpdate } = this.props;
        const { loading, action, editing, actioning, data, search = {}, items = [], tableProps, editProps } = this.state;

        const customers = data.customers.map(v => ({ value: v.id, label: v.name }));
        const voltages = data.voltages.map(v => ({ value: v.id, label: v.name }));
        /*let sites = [];
        if (search.customer) {
            sites = data.customers.filter( v => v.id === search.customer )[0].sites.map( v => ({ value: v.id, label: v.name }));
        }*/
        const departments = data.departments.map( v => ({ value: v.id, label: v.name }));
        // const types = data.types.map( v => ({ value: v.id, label: v.name })); // POST
        const technologies = data.technologies.map( v => ({ value: v.id, label: v.name }));
        const fleets =data.fleets.map( v => ({ value: v.id, label: v.name }));


        let columns = [
            { ...defaultProps.columns.id, Cell: row => (
                <div>
                    {row.original.id}<br />
                    <a className="edit" title={_('col_id_tip', 'SettingsBattery')} onClick={(e) => {
                        this.edit(row.original);
                    } }>
                        <img src="/files/icons/gear.png" width="24px" />
                    </a>
                </div>
                )  },
            { Header: _('col_serialno', 'SettingsBattery'), accessor: 'serialno', Cell: row => (
                <a className="download" title={_('col_serialno_tip', 'SettingsBattery')} onClick={() => { if (onBattery) onBattery({id: row.original.id}); }}>
                    {row.original.serialno}
                </a>
            ) },
            { Header: _('col_brand', 'SettingsBattery'), accessor: 'brand' },
            { Header: _('col_customer', 'SettingsBattery'), accessor: 'customer.description' },
            { Header: _('col_batterytype', 'SettingsBattery'), accessor: 'batterytype' },
            { Header: _('col_nominalvoltage', 'SettingsBattery'), accessor: 'nominalvoltage', className: "number" },
            { Header: _('col_nominalcapacity', 'SettingsBattery'), accessor: 'nominalcapacity', className: "number" },
            { Header: _('col_description', 'SettingsBattery'), accessor: 'description' },
            //{ ...this.SwitchColumn }
        ];
        let actions = [] as string[];
        /*if (checkLevel('dealer')) {
            actions.push('sell');
        }
        if (isLevel('dealer')) {
            actions.push('rent');
        }

        const columnsActs = actions.map( (act) => {
            return {
                Header: '',
                accessor: act,
                maxWidth: 50,
                Cell: this.ActionBtn(act),
                sortable: false,
            }
        });*/
        const columnsActs = [] as any;
        if (!isLevel('customer')) {
            columnsActs.push({
                Header: '',
                accessor: 'mount',
                maxWidth: 150,
                Cell: this.MountBtn(),
                sortable: false,
            });
            columnsActs.push({
                Header: '',
                accessor: 'share',
                maxWidth: 150,
                Cell: this.ShareBtn(),
                sortable: false,
            });
        }

        columns = [...columns, ...columnsActs];
        
        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
                getTdProps: (state, rowInfo, column, instance) => {
                    return {
                        onClick: e => {
                            // if (column.id === "sell" || column.id === "rent" || column.id === "mount" || column.id === "share") {
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            // }
                            // return;
                        },
                    };
                }
            }
        }
        localTableProps.loading = loading;
        
        let localEditProps = {
            ...editProps,
            urlCreateDepartment: this.props.urlCreateDepartment
        } as any;
        if (action === "EDIT") {
            localEditProps = {
                ...localEditProps,
                id: editing,
                item: items.filter(i => i.id === editing)[0]
            };
        }
        if (action === "SELL" || action === "RENT" || action === "MOUNT" || action === "SHARE") {
            localEditProps.id = actioning;
        }
        
		return (
            <>
            
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            {(action === "SELL" || action === "RENT") && !isReadOnly() &&
            <Actions {...localEditProps} action={action.toLowerCase()} onCancel={() => this.setState({action: null})} />
            }
            {(action === "MOUNT" || action === "UNMOUNT") && !isReadOnly() &&
            <BatteryMount
                id={actioning}
                get={this.props.urlWorkflowDevices}
                mount={this.props.urlWorkflowMountBattery}
                unmount={this.props.urlWorkflowUnmountBattery}
                action={action.toLowerCase()}
                onSuccess={() => { this.setState({ action: null }); this.reload(); } }
                onCancel={() => this.setState({ action: null })}
            />
            }
            {(action === "SHARE" || action === "UNSHARE") && !isReadOnly() &&
            <BatteryShare
                id={actioning}
                get={this.props.urlWorkflowCustomers}
                share={this.props.urlWorkflowShareData}
                unshare={this.props.urlWorkflowUnshareData}
                action={action.toLowerCase()}
                onSuccess={() => { this.setState({ action: null }); this.reload(); } }
                onCancel={() => this.setState({ action: null })}
            />
            }
            <Box
                title={_('list_title', 'SettingsBattery')}
                toolbar={!isLevel('customer')? (!isReadOnly()?this.Toolbar:null) : null}
                collapsed={false}
            >
                <div className={style}>
                    <Form onSubmit={(v) => this.search(v)}>
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ filters: formApi.getFormState().values }); }) }
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="battery_sn">{_('field_serialno', 'SettingsBattery')}</label>
                                    <Text field="battery_sn" id="battery_sn" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="brand">{_('field_brand', 'SettingsBattery')}</label>
                                    <Text field="brand" id="brand" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="customer">{_('field_custid', 'SettingsBattery')}</label>
                                    <Select field="customer" id="customer" options={this.addDefaultOption(customers)} className="form-control" />
                                </article>
                                {/*sites &&
                                <article>
                                    <label htmlFor="site">Site</label>
                                    <Select field="site" id="site" options={sites} className="form-control" />
                                </article>
                                */}
                                <article>
                                    <label htmlFor="department">{_('field_deptid', 'SettingsBattery')}</label>
                                    <Select field="department" id="department" options={this.addDefaultOption(departments)} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="fleetname">{_('field_fleet', 'SettingsBattery')}</label>
                                    <Select field="fleetname" id="fleetname" options={this.addDefaultOption(fleets)} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="truck_sn">{_('field_truck_sn', 'SettingsBattery')}</label>
                                    <Text field="truck_sn" id="truck_sn" className="form-control" />
                                </article>
                                {/*
                                <article>
                                    <label htmlFor="fleet">Battery Fleet</label>
                                    <Text field="fleet" id="fleet" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="battery_type">Machine type</label>
                                    <Select field="battery_type" id="battery_type" options={types} className="form-control" />
                                </article>
                                */}
                                <article>
                                    <label htmlFor="technology">{_('field_batterytype', 'SettingsBattery')}</label>
                                    <Select field="technology" id="technology" options={this.addDefaultOption(technologies)} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="voltage">{_('field_nominalvoltage', 'SettingsBattery')}</label>
                                    <Select field="voltage" id="voltage" options={this.addDefaultOption(voltages)} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="capacity">{_('field_nominalcapacity', 'SettingsBattery')}</label>
                                    <Text field="capacity" id="capacity" className="form-control" />
                                </article>
                            </div>
                            <footer>
                                <button type="reset" className="btn btn-secondary">
                                {_(`btn_reset`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_search`, 'Settings')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Box>
            <ReactTable
                {...localTableProps}
                data={items}
                columns={columns}
            />

            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/List/Battery.tsx